'use strict';

var variables = require('./variables-1eb6495a.js');

const light = {
    root: {
        padding: "8px",
        backgroundColor: variables.COLORS.GREYSCALE_98,
        borderTop: `1px ${variables.COLORS.GREYSCALE_0_15} solid`,
    },
};

var MuiDialogActions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  light: light
});

exports.MuiDialogActions = MuiDialogActions;
exports.light = light;
